import { mediaData } from '@/mocks/home';

export default function Media() {
  return (
    <section id="media" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">独家视频</h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">深度访谈与专题盘点，看见娱乐圈的另一个维度</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaData.map((item) => (
            <article
              key={item.id}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-500/90 group-hover:bg-primary-600 transition-colors">
                    <i className="ri-play-fill text-3xl text-background-50 ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-3 right-3 px-2 py-0.5 rounded bg-black/70 text-background-50 text-xs font-medium">
                  {item.duration}
                </span>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-accent-500 text-background-50 text-xs font-medium">
                  {item.type}
                </span>
              </div>
              <div className="p-5">
                <h3 className="text-base font-heading font-bold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}